/* istanbul ignore file */
import React from 'react';
import { Header } from './components/header/Header';
import { Hero } from './components/main/hero/HeroSection';
import { Footer } from './components/footer/Footer';
import { BestRecipes } from './components/main/ourBestRecipes/BestRecipes';
import { BestServices } from './components/main/bestServices/BestServices';
import { HomeClubsSection } from './components/main/homeClubs/HomeClubsSection';
import { Contact } from './components/main/contact/Contact';
import { Blog } from './components/main/blog/Blog';
import { SEOHead } from './components/common/SEOHead';
import './Container.css';

function Container() {
  return (
    <>
      <SEOHead
        title="ShareRecipe — Discover Healthy Recipes, Join Recipe Clubs & Share Home Cooking"
        description="Explore 10,000+ healthy recipes, join interactive Recipe Clubs, get automated grocery checklists, and share delicious home cooking with a vibrant global community. Download the official ShareRecipe app on iOS and Android."
        canonicalUrl="https://sharecipe.net/"
      />
      <Header />
      <Hero />
      <BestRecipes />
      <BestServices />
      <HomeClubsSection />
      <Blog />
      <Contact />
      <Footer />
    </>
  );
}

export default Container;
